import { Box, Card, CardContent, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { SubsciptionCardProps } from './types';
import { Colors } from '../../utils/Colors';

const selectedCss = {
  border: `1px solid ${Colors.ocdGreen}`,
  borderRadius: '16px',
  boxShadow: `5px 10px 10px ${Colors.ocdGreen}`
};
const hoverCss = {
  '&:hover': {
    boxShadow: 'md',
    borderColor: 'neutral.outlinedHoverBorder',
    cursor: 'pointer'
  }
};

export const SubsciptionCard = ({
  onChange,
  selected,
  subscriptionType,
  price
}: SubsciptionCardProps) => {
  const [isSelected, setIsSelected] = useState(selected);

  const onCardClick = () => {
    setIsSelected(true);
    onChange();
  };

  useEffect(() => setIsSelected(selected), [selected]);

  const getHeader = () => {
    if (subscriptionType === 'month') return 'Monthly';
    if (subscriptionType === 'year')
      return 'ANNUALLY ($5.99/MONTH - BEST VALUE!)';
    return '';
  };

  const showPrice = () => {
    const value = Number(price);
    return `$${value / 100}`;
  };

  return (
    <Card
      variant="outlined"
      onClick={onCardClick}
      sx={
        isSelected
          ? {
              ...selectedCss,
              ...hoverCss
            }
          : {
              ...hoverCss
            }
      }
    >
      <CardContent>
        <Typography variant="overline" display="block" gutterBottom>
          {getHeader()}
        </Typography>
        <Box sx={{ display: 'flex' }}>
          <Typography variant="h4" fontWeight="700">
            {showPrice()}
          </Typography>
          <Typography variant="caption">/{subscriptionType}</Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
